import {
  Box,
  SimpleGrid,
  Icon,
  Text,
  Stack,
  useColorModeValue,
  Container,
  Flex,
  Heading,
} from "@chakra-ui/react";
import { ReactComponent as HtmlIcon } from "../../Images/Frontend/html-5.svg";
import { ReactComponent as CssIcon } from "../../Images/Frontend/css-3.svg";
import { ReactComponent as JSIcon } from "../../Images/Frontend/javascript.svg";
import { ReactComponent as ReactIcon } from "../../Images/Frontend/react.svg";
import { ReactComponent as ReduxIcon } from "../../Images/Frontend/redux.svg";
import { ReactComponent as NextIcon } from "../../Images/Frontend/nextjs.svg";
import { ReactComponent as TailwindIcon } from "../../Images/Frontend/tailwindcss.svg";
import { ReactComponent as VueIcon } from "../../Images/Frontend/vue.svg";
import { ReactComponent as EJSIcon } from "../../Images/Frontend/ejs.svg";
import { ReactComponent as ChartJSIcon } from "../../Images/Frontend/chartjs.svg";
import { ReactComponent as FigmaIcon } from "../../Images/Frontend/figma.svg";
import FormikIcon from "../../Images/Frontend/formik.png";

const Feature = ({ title, text, icon, iconType }) => {
  return (
    <Stack
      align={"center"}
      px={8}
      py={4}
      boxShadow={"xl"}
      color={useColorModeValue("gray.600", "gray.600")}
      bgGradient="linear(to-b, gray.50, gray.200)"
      rounded={"lg"}
      transform="scale(1.0)"
      alt="some text"
      objectFit="contain"
      width="100%"
      transition="0.2s ease-in-out"
      _hover={{
        transform: "scale(1.1)",
      }}
    >
      <Flex
        w={16}
        align={"center"}
        justify={"center"}
        color={"white"}
        rounded={"full"}
        mb={1}
      >
        {iconType == "imagefile" ? (
          <img style={{ margin: "8px 0px" }} src={icon} />
        ) : (
          icon
        )}
      </Flex>
      <Text fontWeight={600} fontSize={20}>
        {title}
      </Text>
    </Stack>
  );
};

export default function Frontend() {
  return (
    <>
      <Container maxW={"6xl"}>
        <Stack
          textAlign={"center"}
          align={"center"}
          spacing={{ base: 8, md: 10 }}
          py={{ base: 16, md: 26 }}
        >
          <Heading
            fontWeight={600}
            fontSize={{ base: "3xl", sm: "4xl", md: "6xl" }}
            lineHeight={"110%"}
          >
            <Text as={"span"} color={"blue.400"}>
              Skills
            </Text>
          </Heading>

          <Flex w={"full"}></Flex>
        </Stack>
      </Container>
      <Box p={6} align={"center"}>
        <Heading
          fontSize={"2xl"}
          fontFamily={"body"}
          fontWeight={500}
          align="center"
          p={4}
          color={useColorModeValue("gray.600", "gray.300")}
        >
          Frontend
        </Heading>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 5 }} spacing={16}>
          <Feature
            icon={<Icon as={HtmlIcon} w={20} h={20} />}
            title={"HTML5"}
          />
          <Feature icon={<Icon as={CssIcon} w={20} h={20} />} title={"CSS3"} />
          <Feature
            icon={<Icon as={JSIcon} w={20} h={20} />}
            title={"Javascript"}
          />
          <Feature
            icon={<Icon as={ReactIcon} w={20} h={20} />}
            title={"React"}
          />
          <Feature
            icon={<Icon as={ReduxIcon} w={20} h={20} />}
            title={"Redux"}
          />

          <Feature icon={<Icon as={NextIcon} w={20} h={20} />} title={"Next"} />
          <Feature icon={FormikIcon} iconType={"imagefile"} title={"Formik"} />
          <Feature
            icon={<Icon as={TailwindIcon} w={20} h={20} />}
            title={"TailwindCSS"}
          />
          <Feature icon={<Icon as={VueIcon} w={20} h={20} />} title={"Vue"} />
          <Feature icon={<Icon as={EJSIcon} w={20} h={20} />} title={"EJS"} />
          <Feature
            icon={<Icon as={ChartJSIcon} w={20} h={20} />}
            title={"ChartJS"}
          />
          <Feature
            icon={<Icon as={FigmaIcon} w={20} h={20} />}
            title={"Figma"}
          />
        </SimpleGrid>
      </Box>
    </>
  );
}
